<div class="container-fluid myColorText">
    <nav class="context-breadcrumb" aria-label="breadcrumb  rounded ">
        <ol class="breadcrumb  shadow-lg">
            <li class="breadcrumb-item"><a routerLink="/utilisateur/admin/dashboard">Dashboard administration</a></li>
            <li class="breadcrumb-item active" aria-current="page">Gestion des partenaires</li>
        </ol>
    </nav>
    <div class="row">
        <div class="col-sm-6">
            <div class="card  border-0">
                <div class="card-header border-success generalbgColorV2 ">
                    <h5 class="card-title text-center text-white">ajouter un partenaire</h5>
                </div>
                <div class="card-body">
                    <form [formGroup]="partenaireForm" #f="ngForm" (ngSubmit)="addpartenaire(f.value)">
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputAddress" class="font-weight-bolder">Etablissement Bancaire</label>
                                <input formControlName="etsbancaire" type="text" class="form-control" id="etsbancaire"
                                    placeholder="">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputAddress2" class="font-weight-bolder">Numero identification</label>
                                <input formControlName="nidentification" type="number" class="form-control"
                                    id="nidentification" placeholder="">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputAddress" class="font-weight-bolder">nom responsable</label>
                                <input formControlName="lastName" type="text" class="form-control" id="lastName"
                                    placeholder="">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputAddress2" class="font-weight-bolder">prenom responsable</label>
                                <input formControlName="firstName" type="text" class="form-control" id="firstName"
                                    placeholder="">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputAddress2" class="font-weight-bolder">email de connection</label>
                                <input formControlName="email" type="text" class="form-control" id="email"
                                    placeholder="">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputAddress2" class="font-weight-bolder">contact</label>
                                <input formControlName="phone" type="text" class="form-control" id="phone"
                                    placeholder="">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputCity" class="font-weight-bolder">Ville de l'Etablissement</label>
                                <input formControlName="ville" type="text" class="form-control" id="ville">
                            </div>

                            <div class="form-group col-md-6">
                                <label for="inputZip" class="font-weight-bolder">Quartier</label>
                                <input formControlName="quartier" type="text" class="form-control" id="quartier">
                            </div>
                        </div>


                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputPassword4" class="font-weight-bolder">mot de passe</label>
                                <input formControlName="password" type="password" class="form-control" id="password">

                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputPassword4" class="font-weight-bolder">confirmation mot de passe</label>
                                <input formControlName="confirmPassword" type="password" class="form-control"
                                    id="confirmPassword">
                            </div>
                        </div>
                        <button type="submit" class="btn btn-secondary"
                            [disabled]="!partenaireForm.valid">Ajouter</button>
                    </form>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card border-0">
                <div class="card-header generalbgColorV2">
                    <h5 class="card-title text-white text-center">Liste des partenaires</h5>
                </div>
                <div class="card-body">
                    <div class="row"  *ngFor="let p of partenaireList;">
                        <div class="col-sm-6">
                            <div  *ngIf="p.typ==3" class="card  border-0">
                                <div class="card-header bor-0 textColor generalbgColorV2">
                                    <h5 class="card-title text-success text-center">{{p.etsbancaire}}</h5>
                                  </div>
                                <div class="card-body ">
                                    <h6 class="card-title ">lieu<strong
                                        class="ml-3 text-uppercase">{{p.ville}}</strong>
                                    </h6>
                                    <h6 class="card-title ">Quartier<strong
                                        class="ml-3 text-uppercase">{{p.quartier}}</strong>
                                    </h6>
                                    <h6 class="card-title ">identification<strong
                                        class="ml-3 text-uppercase">{{p.nidentification}}</strong>
                                    </h6>
                                    <button class="btn btn-primary btn-sm" type="button" (click)="editer(p)">editer</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
    </div>
</div>
